import { useState, useEffect } from 'react';

export const usePagination = (props) => {
  const { filteredData, pageSize, path } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setPaginatedData] = useState([]);

  let nao = 0;
  if (typeof window !== 'undefined') {
    let params = new URL(`${window.location.origin}${path}`).searchParams;
    nao = parseInt(params.get('Nao'), 10);
  }

  useEffect(() => {
    if (!pageSize) {
      return;
    }

    if (!filteredData || !filteredData.length) {
      setPaginatedData([]);
      return;
    }

    const idx = !nao ? 0 : Math.floor(nao / pageSize);
    const _currentPage = idx + 1;
    setCurrentPage(_currentPage);

    const firstPageIndex = idx * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    const _paginatedData = (filteredData || []).slice(firstPageIndex, lastPageIndex);
    setPaginatedData(_paginatedData);
  }, [nao, filteredData, pageSize]);

  return {
    paginatedData,
    currentPage
  };
};
